(function () {

  let toast;

  function createToast() {
    toast = document.createElement('div');
    toast.className = 'cart-toast';

    toast.innerHTML = `
      <div class="cart-toast__close">✕</div>
      <div class="cart-toast__title">Added to cart</div>
      <div class="cart-toast__message"></div>
    `;

    document.body.appendChild(toast);

    toast.querySelector('.cart-toast__close').addEventListener('click', hideToast);
  }

  function showToast(message) {
    if (!toast) createToast();

    toast.querySelector('.cart-toast__message').textContent = message;

    toast.classList.add('is-visible');

    clearTimeout(toast._timeout);
    toast._timeout = setTimeout(hideToast, 3500);
  }

  function hideToast() {
    if (!toast) return;
    toast.classList.remove('is-visible');
  }

  // 🔔 PUBLIC EVENT
  document.addEventListener('cart:toast', e => {
    showToast(e.detail?.message || 'Item added to your cart');
  });

})();
